import styled from "styled-components";

export const Wrapper = styled.div`
  .action {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .accept {
    color: #5d78ff;
    border: 1px solid #5d78ff;
    font-weight: 700;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    padding: 4px 22px;
    border-radius: 3px;
    word-break: normal;
    text-decoration: none;
  }

  .reject {
    padding: 4px 22px;
    color: #ff2828;
    font-weight: 700;
    border: 1px solid #ff2828 !important;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }
  .userName {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .profileIcon {
    width: 16px;
    height: 16px;
    stroke: blue;
    fill: blue;
    margin-left: 5px;
  }
  .viewHistory {
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    height: 30px;
    outline: none;
    padding: 0 10px;
    font-weight: 600;
    text-decoration: none;
    line-height: 25px;
    color: #000;
  }
  .nameColumn {
    min-width: 200px;
  }
  .idColumn {
    width: 100px;
  }
  .reasonColumn {
    min-width: 350px;
  }
  .viewChats{
    display: block;
    text-decoration: none;
    color: #5D78FF;
  }
`;
